<div class="wetter_content_container">

  <table mat-table matSort matSortActive="ort"
         matSortDirection="desc"
         [dataSource]="dataSource"
         class="mat-elevation-z4">

    <!--    <ng-container matColumnDef="id">-->
    <!--      <th mat-header-cell mat-sort-header *matHeaderCellDef>id</th>-->
    <!--      <td mat-cell *matCellDef="let element">{{element?.ort?.id}}</td>-->
    <!--    </ng-container>-->

    <ng-container matColumnDef="ort">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Ort</th>
      <td mat-cell *matCellDef="let element">{{element?.ort?.name}}</td>
    </ng-container>

    <ng-container matColumnDef="tiefsttemperatur">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Tiefsttemperatur nachts (°C)</th>
      <td mat-cell
          *matCellDef="let element">{{converter.convertDecimalWithComma(element?.tag00?.werteGanzerTag?.luftTemperaturMinimum?.wert)}}</td>
    </ng-container>

    <ng-container matColumnDef="hoechsttemperatur">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Höchsttemperatur morgen (°C)</th>
      <td mat-cell
          *matCellDef="let element">{{converter.convertDecimalWithComma(element?.tag00?.werteGanzerTag?.luftTemperaturMaximum?.wert)}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
